import { render, staticRenderFns } from "./DialogPanel.vue?vue&type=template&id=7749f9b6&"
import script from "./DialogPanel.vue?vue&type=script&lang=js&"
export * from "./DialogPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports